// Service file metadata is persisted by both the trip and Library APIs. Keep
// stock titles in originalname and identify them by type on reopen; option.value
// and file.name remain the storage filename, including for blank titles.
export const SERVICE_STOCK_PHOTO_TYPE = 'stockPhoto';
